import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';
import SearchBar from '../../shared/searchBar/searchBar.component';
import { calcSettingsBookToTaxDifferencesColumnDefs } from '../../shared/columnDefinitions/bookToTaxDifferences';

export const BookToTaxDifferencesPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    countryTaxType: PropTypes.string,
    description: PropTypes.string,
    exceptionAccount: PropTypes.string,
    exceptionBasis: PropTypes.string,
    disallowedPercentage: PropTypes.number,
    deferredTaxAccount: PropTypes.string,
  })
);

class BookToTaxDifferences extends PureComponent {
  static propTypes = {
    bookToTaxDifferences: BookToTaxDifferencesPropTypes,
  };

  state = {
    bookToTaxDifferencesFilter: '',
  };

  setBookToTaxDifferencesFilter = filter => {
    this.setState({ bookToTaxDifferencesFilter: filter });
  };

  unsetBookToTaxDifferencesFilter = () => {
    this.setState({ bookToTaxDifferencesFilter: '' });
  };

  render() {
    const { bookToTaxDifferences } = this.props;
    const { bookToTaxDifferencesFilter } = this.state;

    return (
      <div className="tax-rates container-fluid">
        <div className="search-bar-absolute">
          <SearchBar
            onCancel={this.unsetBookToTaxDifferencesFilter}
            onSearch={this.setBookToTaxDifferencesFilter}
            value={bookToTaxDifferencesFilter}
          />
        </div>
        <div className="row">
          <div className="col">
            <div
              className="calc-settings-grid"
            >
              <AgGrid
                columnDefs={calcSettingsBookToTaxDifferencesColumnDefs}
                rowData={bookToTaxDifferences}
                quickFilterText={bookToTaxDifferencesFilter}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BookToTaxDifferences;
